import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useOurServices } from "../../hooks/ourServicesHooks";
import { urlFor } from "../../lib/sanity";
import "./services-grid.css";

const ServicesGrid = () => {
  const [showAll, setShowAll] = useState(false);
  const { services, loading, error } = useOurServices();

  if (loading) {
    return (
      <section className="services-grid-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="services-grid-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="alert alert-danger" role="alert">
                Error: {error}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!services || services.length === 0) {
    return null;
  }

  const initialServices = services.slice(0, 5);
  const servicesToShow = showAll ? services : initialServices;

  return (
    <section className="services-grid-section">
      <div className="container">
        <div className="services-grid card-group row">
          {servicesToShow.map((service, index) => (
            <div
              key={service.title + index}
              className="service-card col-lg-4 col-md-6 px-2 mb-3"
            >
              <div className="flipcard">
                <div className="flipcard-inner">
                  {/* Front of the card */}
                  <div className="flipcard-front">
                    <div className="service-icon">
                      {service.image && (
                        <img
                          src={urlFor(service.image).url()}
                          alt={service.title}
                        />
                      )}
                    </div>
                    <h3 className="service-title">{service.title}</h3>
                  </div>
                  {/* Back of the card */}
                  <div className="flipcard-back">
                    <p className="service-description">{service.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button (only when there are more services) */}
        {!showAll && services.length > 5 && (
          <div className="load-more-button" onClick={() => setShowAll(true)}>
            <FaChevronDown size={30} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesGrid;
